










import { mapState } from "vuex";
import {UtilityHelper} from "@/helpers/UtilityHelper";
export default {
  name: "Loader",
  data() {
    return {
      TRANSLATION_KEY: "Loader",
    };
  },
  computed: {
    ...mapState({
      isLoaderText: (state: any) => state.isLoaderText,
      isLoadingThumbnail: (state: any) => state.isLoadingThumbnail,
    }),
    UtilityHelper() {
      return UtilityHelper
    },
  },
};
